import styled from 'styled-components';

export const DetailsWraper = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }
`;
